// @flow
import { get } from 'lodash';

const initializededViews =
  window.initializededViews || (window.initializededViews = {});

// export const getViewClass = viewKey => get(window.views, viewKey);
export const getViewClass = viewKey => get(window, viewKey);

export const loadView = viewKey => initializededViews[viewKey];

export const renderView = (
  viewKey,
  force = false,
  viewArguments = [],
  renderArgs = [],
) => {
  const View = getViewClass(viewKey);

  const initView = () => {
    initializededViews[viewKey] = new View(...viewArguments);
  };

  if (!initializededViews[viewKey]) {
    initView();
  } else if (force) {
    initializededViews[viewKey].destroy();
    initView();
  }

  initializededViews[viewKey].render(...renderArgs);

  return initializededViews[viewKey];
};

export const clearView = viewKey => {
  const view = initializededViews[viewKey];
  initializededViews[viewKey] = null;
  return view;
};
